'use client';

import { classNames } from '@schuelerhilfe/shared/src/utils/classNames';
import type { RichTextBlockResolved } from './types';
import { RichText } from '@/lib/render/RichText';

const ALIGNMENTS: Record<
  NonNullable<RichTextBlockResolved['alignment']>,
  string
> = {
  left: 'text-left',
  center: 'text-center',
  right: 'text-right',
};

/*
 * A *measure*, not a container (70.14-Widget-Width § 5). `narrow` constrains the
 * line length inside the space the wrapper already gave this block; `wide` adds
 * nothing and simply fills it.
 *
 * Both used to carry their own gutter — `narrow` had `px-4` and no `lg:px-9` —
 * so choosing `narrow` silently chose a different gutter too, and the text
 * started 20px in from every widget above it. That was the SH-440 bug.
 */
const WIDTHS: Record<NonNullable<RichTextBlockResolved['width']>, string> = {
  narrow: 'mx-auto max-w-3xl',
  wide: '',
};

export function RichTextBlockComponent({
  resolved,
}: {
  resolved: RichTextBlockResolved;
}) {
  // `??`, not destructuring defaults: an unset Strapi enum arrives as `null`,
  // and a `null` width would drop the max-width altogether.
  const { body } = resolved;
  const alignment = resolved.alignment ?? 'left';
  const width = resolved.width ?? 'narrow';
  if (!body) {
    return null;
  }
  return (
    <div
      className={classNames(
        // `benefits-checkmarks` (globals.css): unordered lists render with
        // primary-colored checkmark bullets; ordered lists keep their numbers.
        'benefits-checkmarks',
        WIDTHS[width],
        ALIGNMENTS[alignment],
      )}
    >
      <RichText nodes={body} />
    </div>
  );
}
